import { isString } from './helpers';
function isConditionPrimitive(value) {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
}
function sanitizeValidSubConditions(raws) {
  return raws.map(sanitizeCondition).filter(c => c !== null);
}
function sanitizeAndCondition(c) {
  const conditions = sanitizeValidSubConditions(c.and);
  return conditions.length > 0 ? {
    and: conditions
  } : null;
}
function sanitizeOrCondition(c) {
  const conditions = sanitizeValidSubConditions(c.or);
  return conditions.length > 0 ? {
    or: conditions
  } : null;
}
function sanitizeNotCondition(c) {
  const inner = sanitizeCondition(c.not);
  return inner ? {
    not: inner
  } : null;
}
function sanitizeFormatWithTimezone(c) {
  if ('formatWithTimezone' in c && isString(c.formatWithTimezone) && c.formatWithTimezone.length > 0) {
    return c.formatWithTimezone;
  }
  return undefined;
}
function sanitizePathCondition(path, c) {
  if ('equals' in c && isConditionPrimitive(c.equals)) return {
    path,
    equals: c.equals
  };
  if ('notEquals' in c && isConditionPrimitive(c.notEquals)) return {
    path,
    notEquals: c.notEquals
  };
  if ('equalsPath' in c && isString(c.equalsPath) && c.equalsPath.length > 0) {
    const formatWithTimezone = sanitizeFormatWithTimezone(c);
    return formatWithTimezone ? {
      path,
      equalsPath: c.equalsPath,
      formatWithTimezone
    } : {
      path,
      equalsPath: c.equalsPath
    };
  }
  if ('greaterThan' in c && typeof c.greaterThan === 'number') return {
    path,
    greaterThan: c.greaterThan
  };
  if ('lessThan' in c && typeof c.lessThan === 'number') return {
    path,
    lessThan: c.lessThan
  };
  return {
    path
  };
}
export function sanitizeCondition(raw) {
  if (typeof raw !== 'object' || raw === null) return null;
  const c = raw;
  if (Array.isArray(c.and)) return sanitizeAndCondition(c);
  if (Array.isArray(c.or)) return sanitizeOrCondition(c);
  if ('not' in c) return sanitizeNotCondition(c);
  if (!isString(c.path) || c.path.length === 0) return null;
  return sanitizePathCondition(c.path, c);
}